/**
 * @author Rejo Varghese
 * @description Ticket search v2
 */
import React, { useState, useMemo } from "react";
import { Button, Input, Row, Col ,Table, Select, DatePicker, message, Tooltip, Radio } from 'antd';
import { fetchTicketSearchV2 } from '../../actions/reports.action';
import { isValid, getValuesOfJSonObject, isValidArrayWithValues, isValidString } from '../../utils/utilities';
import { loadingAction } from '../../actions/loading-actions';
import { useDispatch } from "react-redux";
import { getUIDateFormat, getAPIDateFormat, getDateTimeFormat, getLocalDateAndTime, incrementDays} from '../../utils/date.utils';
// import { Printer } from '../../components/custom-components/custom-component';
import { getPaginationDetails, getDefaultPageSize, getRangeOptions } from './reports.module';
import { TicketSearchRowExpand } from "../../components/ticket-search-component/ticket-search-component";
import { fetchTicketDetailsByPNR } from "../../actions/ticket.action";
import './../../styles/report.style.scss';


const formatPNRTicketData = (tktData) => {
    let travellers = tktData.traveller;
    let ticket = tktData.ticket, formattedData;
    travellers.map((traveller, ind) => {
        let isPartial = ticket.ticket_status!=traveller.traveller_status?true:false;
        let pnrTravellerData = {
            "pnr": ticket.pnr,
            "doj": tktData.pickupDetails.travel_date,
            "start_date": getUIDateFormat(tktData.trip.start_date),
            "origin": tktData.route.origin,
            "destination": tktData.route.destination,
            "full_name": traveller.full_name,
            "age": traveller.age,
            "gender": traveller.gender,
            "discounted_fare": traveller.discounted_fare,
            "fare": traveller.fare,
            "total_gst": traveller.total_gst,
            "net_commission": traveller.net_commission,
            "traveller_status": traveller.traveller_status,
            "cancellation_time": traveller.cancellation_time,
            "cancellation_penalty": traveller.cancellation_penalty,
            "phone_number": ticket.phone_number,
            "email_id": ticket.email_id,
            "seat": traveller.seat_number,
            "agent_name": tktData.agent.name,
            "booking_time": ticket.booking_time,
            "ticket_status": ticket.ticket_status,
            "amount_paid": ticket.amount_paid,
            "description": tktData.schedule.description,
            "order_no": isValid(tktData.transactionDetails.order_no)?tktData.transactionDetails.order_no:''
        }
        if (ind==0) {
            formattedData = {...pnrTravellerData};
            formattedData["doj"] = getUIDateFormat(formattedData["doj"]);
            formattedData["booking_time"] = getLocalDateAndTime(formattedData["booking_time"]);
            formattedData["travellerData"] = [{...pnrTravellerData}];
        }
        else {
            formattedData["seat"] += "," + traveller.seat_number;
            formattedData["travellerData"].push({...pnrTravellerData})
        }
        if (isPartial) {
            formattedData["isPartial"] = isPartial;
        }
    })
    return [formattedData];
}

const formatTicketData = (tickets) => {
    let ticketData = {}, transctionList = [], index = 0, orderList = {};
    tickets.map((ticket) => {
        let pnr = ticket.pnr;
        if(isValid(ticketData[pnr])) {
            let seat = ticketData[pnr]['seat'];
            seat+=","+ticket.seat_number
            ticketData[pnr]['seat'] = seat;
            ticketData[pnr]["travellerData"].push(ticket);
            let recordedStatus = ticketData[pnr]['ticket_status'];
            if (recordedStatus!=ticket.traveller_status) {
                ticketData[pnr]['isPartial'] = true;
            }
        }
        else {
            index++;
            let isPartial = ticket.ticket_status!=ticket.traveller_status?true:false;
            let formattedData = {
                "key": index,
                "pnr": ticket.pnr,
                "doj": getUIDateFormat(incrementDays(ticket.start_date, ticket.origin_day)),
                "start_date": getUIDateFormat(ticket.start_date),
                "origin": ticket.origin,
                "destination": ticket.destination,
                "full_name": ticket.full_name,
                "phone_number": ticket.phone_number,
                "seat": ticket.seat_number,
                "agent_name": ticket.agent_name,
                "booking_time": getLocalDateAndTime(ticket.booking_time),
                "ticket_status": ticket.ticket_status,
                "amount_paid": ticket.amount_paid,
                "description": ticket.description || ticket.schedule_description || '',
                "vehicle": ticket.vechicle_no || ticket.vehicle_no || ticket.vehicle_number || ticket.bus_number || '',
                "travellerData": [ticket],
                "isPartial": isPartial
            }
            ticketData[pnr] = formattedData;
        }
    });
    return getValuesOfJSonObject(ticketData);
}

const RenderReport =(props)=>{

    const {
        tickets,
        pagination,
        setLoading,
        pnrFetchedData,
        setPnrFetchedData
    } = props;

    const [page, setPage] = useState(1);
    const [paginationSize, setPaginationSize] = useState(getDefaultPageSize);

    const assignStatusColor = (record) => {
        let statusColor;
        if (record.ticket_status== "Confirmed") {
            statusColor= "#2BB193";
        }
        else if (record.ticket_status == "Blocked") {
            statusColor = "#FFA000";
        }
        else {
            statusColor = "#ED716C";
        }
        return (
            <div>
                <Row>
                    <span style={{color: statusColor, fontWeight: 'bold'}}>{record.ticket_status}</span>
                </Row>
                {record.isPartial&&record.ticket_status== "Confirmed"&&
                    <Row>
                        <span style={{color: "#EA4025", fontWeight: 'bold', marginLeft: '2em'}}>P</span>
                    </Row>
                }
            </div>
        )
    }

    

    const columns=[
        {
            title:'SN',
            key:'index',
            render : (text, record, index) => (page - 1) * paginationSize + index+1
        },
        {
            title:'PNR',
            key:'pnr',
            dataIndex : 'pnr'
        },
        {
            title: () => <Tooltip title="Trip Start Date">Trip Date</Tooltip>,
            key:'start_date',
            dataIndex : 'start_date'
        },
        {
            title:'Origin',
            key:'origin',
            dataIndex : 'origin'
        },
        {
            title:'Destination',
            key:'destination',
            dataIndex : 'destination'
        },
        {
            title:'Name',
            key:'full_name',
            dataIndex : 'full_name'
        },
        {
            title:'Phone',
            key:'phone_number',
            dataIndex : 'phone_number'
        },
        {
            title:'Seats',
            key:'seat',
            dataIndex : 'seat'
        },
        {
            title:'Agent',
            key:'agent_name',
            dataIndex : 'agent_name'
        },
        {
            title: () => <Tooltip title="Boooking Date & Time">Book DT</Tooltip>,
            key:'booking_time',
            dataIndex : 'booking_time'
        },
        {
            title:'Status',
            key:'ticket_status',
            dataIndex : 'ticket_status',
            render : (text, record, index) => {
                return assignStatusColor(record);
            }
        },
        {
            title: () => <Tooltip title="Amount Paid">Amount</Tooltip>,
            key:'amount_paid',
            dataIndex : 'amount_paid'
        }
    ];

    return(
        <div className = "ticket-search-table">
                <Table
                    dataSource={tickets}
                    columns={columns}
                    bordered= {false}
                    expandable={{
                        expandedRowRender: (record) => {
                            return <div className="expand-ticket-search"><TicketSearchRowExpand
                                        TicketData = {record}
                                        pnrFetchedData = {pnrFetchedData}
                                        setPnrFetchedData = {setPnrFetchedData}
                                        selectedPNR = {record.pnr}
                                        assignStatusColor = {assignStatusColor}
                                        setLoading = {setLoading}
                                /></div>
                        }
                    }}
                    rowClassName="ticket-search-table-row"
                    expandRowByClick
                    pagination={getPaginationDetails(pagination, setPage, paginationSize, setPaginationSize)}
                    className="bordered-table"
                />
        </div>
    )
}

export const TicketSearchReportV2 = () => {

    const { RangePicker } = DatePicker;
    let allowedMaxDaysRange=31;

    const [tickets,setTickets]=useState(undefined);
    const [showReport,setShowReport]=useState(false);
    const [selectedTicketValue, setSelectedTicketValue] = useState('Mobile_Number');
    const [selectedDateValue, setSelectedDateValue] = useState('travel_date');
    const [dateInput, setDateInput] = useState(null);
    const [dateInputKey, setDateInputKey] = useState(0);
    const [ticketInput, setTicketInput] = useState('');
    const [pnrFetchedData, setPnrFetchedData] = useState({});

    const [cityFilter, setCityFilter] = useState(null);
    const [citySide, setCitySide] = useState('either');
    const [tripFilter, setTripFilter] = useState(null);
    const [vehicleFilter, setVehicleFilter] = useState(null);
    const [agentFilter, setAgentFilter] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);
    const [sortField, setSortField] = useState('booking_time');
    const [sortOrder, setSortOrder] = useState('desc');

    const sortableColumns = [
        { value: 'pnr', label: 'PNR' },
        { value: 'start_date', label: 'Trip Date' },
        { value: 'origin', label: 'Origin' },
        { value: 'destination', label: 'Destination' },
        { value: 'full_name', label: 'Name' },
        { value: 'phone_number', label: 'Phone' },
        { value: 'seat', label: 'Seats' },
        { value: 'agent_name', label: 'Agent' },
        { value: 'booking_time', label: 'Booking Date' },
        { value: 'ticket_status', label: 'Status' },
        { value: 'amount_paid', label: 'Amount' }
    ];

    const buildOptions = (values) => {
        const list = [...new Set((values || []).filter(Boolean))].sort();
        return list.map(v => ({ value: v, label: v }));
    }

    const cityOptions = useMemo(() => {
        if (!isValidArrayWithValues(tickets)) return [];
        const all = [];
        tickets.forEach(t => { if (t.origin) all.push(t.origin); if (t.destination) all.push(t.destination); });
        return buildOptions(all);
    }, [tickets]);

    const tripOptions = useMemo(() => {
        if (!isValidArrayWithValues(tickets)) return [];
        const trips = tickets.map(t => isValidString(t.description) ? t.description : `${t.origin || ''} - ${t.destination || ''}`);
        return buildOptions(trips);
    }, [tickets]);

    const vehicleOptions = useMemo(() => buildOptions((tickets || []).map(t => t.vehicle)), [tickets]);

    const agentOptions = useMemo(() => buildOptions((tickets || []).map(t => t.agent_name)), [tickets]);

    const statusOptions = useMemo(() => buildOptions((tickets || []).map(t => t.ticket_status)), [tickets]);

    const displayedTickets = useMemo(() => {
        if (!isValidArrayWithValues(tickets)) return tickets;
        let rows = tickets.slice();
        if (isValidString(cityFilter)) {
            rows = rows.filter(r => {
                if (citySide === 'from') return r.origin === cityFilter;
                if (citySide === 'to') return r.destination === cityFilter;
                return r.origin === cityFilter || r.destination === cityFilter;
            });
        }
        if (isValidString(tripFilter)) {
            rows = rows.filter(r => {
                const tripVal = isValidString(r.description) ? r.description : `${r.origin || ''} - ${r.destination || ''}`;
                return tripVal === tripFilter;
            });
        }
        if (isValidString(vehicleFilter)) {
            rows = rows.filter(r => r.vehicle === vehicleFilter);
        }
        if (isValidString(agentFilter)) {
            rows = rows.filter(r => r.agent_name === agentFilter);
        }
        if (isValidString(statusFilter)) {
            rows = rows.filter(r => r.ticket_status === statusFilter);
        }
        if (isValidString(sortField)) {
            const dir = sortOrder === 'asc' ? 1 : -1;
            rows.sort((a, b) => {
                const av = a[sortField];
                const bv = b[sortField];
                if (av === bv) return 0;
                if (av === undefined || av === null || av === '') return 1;
                if (bv === undefined || bv === null || bv === '') return -1;
                if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * dir;
                return String(av).localeCompare(String(bv), undefined, { numeric: true }) * dir;
            });
        }
        return rows;
    }, [tickets, cityFilter, citySide, tripFilter, vehicleFilter, agentFilter, statusFilter, sortField, sortOrder]);

    const handleReset = () => {
        setTicketInput('');
        setDateInput(null);
        setDateInputKey(k => k + 1);
        setSelectedTicketValue('Mobile_Number');
        setSelectedDateValue('travel_date');
        setCityFilter(null);
        setCitySide('either');
        setTripFilter(null);
        setVehicleFilter(null);
        setAgentFilter(null);
        setStatusFilter(null);
        setSortField('booking_time');
        setSortOrder('desc');
        setTickets(undefined);
        setShowReport(false);
        setPnrFetchedData({});
    }

    const dispatch=useDispatch();

    const onSuccess=(data)=>{
        setShowReport(true);
        setLoading(false);

        setTickets(formatTicketData(data));
    }

    const onFailure=()=>{
        setLoading(false);
    }

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const handleTicketChange = (value) => {
        setSelectedTicketValue(value);
    };

    const handleDateChange = (value) => {
        setSelectedDateValue(value);
    };

    const handleSubmit = () => {
        if(isValidString(ticketInput) || isValidArrayWithValues(dateInput)) {
            if (!isValidString(ticketInput)&&isValidArrayWithValues(dateInput)&&dateInput[1].diff(dateInput[0],"days")>=allowedMaxDaysRange) {
                message.error(`Please select a date range with in ${allowedMaxDaysRange} days`);
            }
            else {
                if (['Mobile_Number', 'email_id', 'Passenger_name'].includes(selectedTicketValue)&&!isValidArrayWithValues(dateInput)) {
                    message.error("Please select date range to complete the search");
                }
                else {
                    setLoading(true);
                    setShowReport(false);
                    setCityFilter(null);
                    setCitySide('either');
                    setTripFilter(null);
                    setVehicleFilter(null);
                    setAgentFilter(null);
                    setStatusFilter(null);
                    let isBooking = selectedDateValue=='booking_date'?true:false;
                    let dateRange = {}
                    dateRange['fromDate'] = isValidArrayWithValues(dateInput)?getAPIDateFormat(dateInput[0]): null;
                    dateRange['toDate'] = isValidArrayWithValues(dateInput)?getAPIDateFormat(dateInput[1]): null;
                    setPnrFetchedData({});
                    if (selectedTicketValue == "PNR") {
                        fetchTicketDetailsByPNR(ticketInput, (tktData) => {
                            setShowReport(true);
                            setLoading(false);
                            setTickets(formatPNRTicketData(tktData));
                            let tmpPnrData = pnrFetchedData;
                            let formattedTicketLogs = {}
                            formattedTicketLogs["travellerLogs"] = tktData["logs"]["travellerLogs"];
                            tmpPnrData[ticketInput] = tktData;
                            tmpPnrData[ticketInput]['pnrLogs'] = formattedTicketLogs;
                            setPnrFetchedData(tmpPnrData)
                        }, ()=> {
                            setLoading(false);
                        })
                    }
                    else {
                        fetchTicketSearchV2(selectedTicketValue, ticketInput,isBooking, dateRange, onSuccess,onFailure);
                    }
                }
            }
        }
        else {
            message.error("Please enter a valid input");
        }
    }

    const selectTicketOptions = [
        {
            value: 'Mobile_Number',
            label: 'Phone',
        },
        {
            value: 'PNR',
            label: 'PNR',
        },
        {
            value: 'email_id',
            label: 'Email id',
        },
        {
            value: 'Passenger_name',
            label: 'Passenger Name',
        },
        {
            value:"order_no",
            label:"Transaction ID"
        }
    ]

    const selectDateOptions = [
        {
            value: 'travel_date',
            label: 'Travel Date',
        },
        {
            value: 'booking_date',
            label: 'Booking Date',
        }
    ]

    return (
            <div className="ticket-search-inner-div">
                <div className = "ticket-search-select">
                    <Row justify="space-around" align="middle" gutter={[16,16]}>
                    <Input.Group compact >
                        <Col>
                        <Select
                            value={selectedDateValue}
                            style={{
                                width: 150,
                                height: 40,
                            }}
                            onChange={handleDateChange}
                            bordered= {true}
                            options={selectDateOptions}
                        />
                        <RangePicker
                                        key={dateInputKey}
                                        ranges={getRangeOptions(allowedMaxDaysRange)}
                                        value={dateInput}
                                        onChange = {setDateInput}
                                        size ={"large"}
                                    />
                        </Col>
                        <Col>
                        <Select
                            value={selectedTicketValue}
                            style={{
                                width: 160,
                                height: 40,
                            }}
                            onChange={handleTicketChange}
                            bordered= {true}
                            options={selectTicketOptions}
                        />
                        <Input
                            style={{width: 200,height: 40}}
                            value={ticketInput}
                            onChange={(e) => {setTicketInput(e.target.value)}}
                        />
                        </Col>
                        <Col>
                        <Button type="primary" 
                        style={{ marginRight: 8 }}
                        onClick={()=>{
                            handleSubmit();
                            }}
                        >Search</Button>
                        <Button onClick={handleReset} >Reset</Button>
                        </Col>
                    </Input.Group>
                    </Row>
                </div>
                {showReport&&
                    <div>
                        <Row className="marginTop ticket-search-filter-row" justify="space-between" align="middle" gutter={[12,12]} style={{marginTop: 12}}>
                            <Col>
                                <Row gutter={[10,10]} align="middle">
                                    <Col>
                                        <div className="ts-filter-pill">
                                            <span className="ts-filter-pill-label">City</span>
                                            <Select
                                                allowClear
                                                bordered={false}
                                                placeholder="All cities"
                                                value={cityFilter}
                                                onChange={setCityFilter}
                                                options={cityOptions}
                                                className="ts-filter-pill-select"
                                                dropdownMatchSelectWidth={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <Radio.Group
                                            className="ts-city-side-toggle"
                                            value={citySide}
                                            onChange={(e) => setCitySide(e.target.value)}
                                            optionType="button"
                                        >
                                            <Radio.Button value="either">Either</Radio.Button>
                                            <Radio.Button value="from">From</Radio.Button>
                                            <Radio.Button value="to">To</Radio.Button>
                                        </Radio.Group>
                                    </Col>
                                    <Col>
                                        <div className="ts-filter-pill">
                                            <span className="ts-filter-pill-label">Trip</span>
                                            <Select
                                                allowClear
                                                bordered={false}
                                                placeholder="All trips"
                                                value={tripFilter}
                                                onChange={setTripFilter}
                                                options={tripOptions}
                                                className="ts-filter-pill-select"
                                                dropdownMatchSelectWidth={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={`ts-filter-pill${!isValidArrayWithValues(vehicleOptions) ? ' ts-filter-pill-disabled' : ''}`}>
                                            <span className="ts-filter-pill-label">Vehicle</span>
                                            <Select
                                                allowClear
                                                bordered={false}
                                                placeholder="All"
                                                value={vehicleFilter}
                                                onChange={setVehicleFilter}
                                                options={vehicleOptions}
                                                className="ts-filter-pill-select"
                                                dropdownMatchSelectWidth={false}
                                                disabled={!isValidArrayWithValues(vehicleOptions)}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="ts-filter-pill">
                                            <span className="ts-filter-pill-label">Agent</span>
                                            <Select
                                                allowClear
                                                bordered={false}
                                                placeholder="All"
                                                value={agentFilter}
                                                onChange={setAgentFilter}
                                                options={agentOptions}
                                                className="ts-filter-pill-select"
                                                dropdownMatchSelectWidth={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="ts-filter-pill">
                                            <span className="ts-filter-pill-label">Status</span>
                                            <Select
                                                allowClear
                                                bordered={false}
                                                placeholder="All"
                                                value={statusFilter}
                                                onChange={setStatusFilter}
                                                options={statusOptions}
                                                className="ts-filter-pill-select"
                                                dropdownMatchSelectWidth={false}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Row gutter={[10,10]} align="middle">
                                    <Col>
                                        <div className="ts-filter-pill">
                                            <span className="ts-filter-pill-label">Sort by</span>
                                            <Select
                                                bordered={false}
                                                value={sortField}
                                                onChange={setSortField}
                                                options={sortableColumns}
                                                className="ts-filter-pill-select"
                                                dropdownMatchSelectWidth={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col>
                                        <div
                                            className="ts-sort-order-pill"
                                            onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <span>{(sortableColumns.find(c => c.value === sortField) || {}).label || 'Sort'}</span>
                                            <span className="ts-sort-order-arrow">{sortOrder === 'asc' ? '↑' : '↓'}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="marginTop" gutter={[16,16]}>
                            <Col>
                                <RenderReport
                                    tickets={displayedTickets}
                                    pagination={true}
                                    setLoading = {setLoading}
                                    pnrFetchedData = {pnrFetchedData}
                                    setPnrFetchedData = {setPnrFetchedData}
                                />
                            </Col>
                        </Row>
                    </div>
                }
            </div>
    )
}